import { MOSTRA_SEU_APROVA_TRIGGER_KEYS, MostraSeuAprovaTriggerKey } from './data';

/**
 * Gatilho que precisa sobreviver a um recarregamento da página.
 *
 * Alguns fluxos terminam em `window.location.reload()` — gerar o cronograma é
 * um deles. Chamar `fire()` ali não funciona: o recarregamento aborta o
 * registro e leva o modal junto. Em vez disso o gatilho fica guardado e é
 * disparado quando a aplicação sobe de novo.
 *
 * `sessionStorage` e não `localStorage`: um gatilho pendente que nunca foi
 * consumido deve morrer com a aba, não reaparecer dias depois.
 */
const PENDING_KEY = 'at:mostra-seu-aprova:pending-trigger';

const isTriggerKey = (value: unknown): value is MostraSeuAprovaTriggerKey =>
  typeof value === 'string' &&
  (MOSTRA_SEU_APROVA_TRIGGER_KEYS as string[]).includes(value);

/** Guarda o gatilho para ser disparado depois do recarregamento. */
function queuePendingTrigger(triggerKey: MostraSeuAprovaTriggerKey): void {
  try {
    sessionStorage.setItem(PENDING_KEY, triggerKey);
  } catch {
    // sessionStorage indisponível — o gatilho se perde, que é melhor do que
    // quebrar o fluxo que o aluno estava concluindo.
  }
}

/**
 * Lê e descarta o gatilho pendente. Devolve `null` quando não há nenhum ou
 * quando o valor guardado não é mais uma chave válida (a campanha mudou entre
 * o `queue` e o `consume`).
 */
function consumePendingTrigger(): MostraSeuAprovaTriggerKey | null {
  try {
    const stored = sessionStorage.getItem(PENDING_KEY);

    if (stored === null) return null;

    sessionStorage.removeItem(PENDING_KEY);

    return isTriggerKey(stored) ? stored : null;
  } catch {
    return null;
  }
}

export { consumePendingTrigger, queuePendingTrigger };
